import React from 'react';
import '../styles/loader.styles.css';

class Loader extends React.Component {
  render() {
    return <div className="loader"><div></div><div></div><div></div><div></div></div>;
  }
}
	
export default Loader;